export enum CART_APPOINMENT_ENTRY_TYPE {
  INTERNAL_NOTE,
  EXTERNAL_NOTE,
  SERVICE,
}
